// extracted by mini-css-extract-plugin
export default {"container":"authentication_container__Sx0IY","logo":"authentication_logo__6yFUd","form":"authentication_form__C-gzn","inputbox":"authentication_inputbox__gk0nc"};